import axios from 'axios'
import {ResponseObject, ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  CleaningStatusDto,
  CleaningStatusRow,
  CleaningStatusTotalRow,
  ResponseTotalScanActivity,
  ScanActivityDto,
  ScanActivityResponse,
} from '../model/cleaningStatus.model'
import {updateObservation} from '../../lavanderia/services'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const CLEANING_STATUS_SERVICES = {
  getReportState: (dto: CleaningStatusDto) => {
    return axios.post<ResponseObjectPaginated<CleaningStatusRow[]>>(
      `${BASEURL}/Scan/getReportState`,
      dto,
    )
  },
  getReportStateTotals: (dto: CleaningStatusDto) => {
    return axios.post<CleaningStatusTotalRow>(`${BASEURL}/Scan/getReportStateTotalHab`, dto)
  },
  getListEscaneoActividad: (dto: ScanActivityDto) => {
    return axios.post<ResponseTotalScanActivity<ScanActivityResponse[]>>(
      `${BASEURL}/Scan/getListEscaneoActividad`,
      dto,
    )
  },
  updateObservation: (data: {
    EscaneoActividadId: string
    MotivoId: string
    Comentarios: string
  }) => {
    return axios.post<ResponseObjectUpload>(`${BASEURL}/Scan/UpdateObservacion`, data)
  },
  attachDocument: (data: FormData, escaneoActividadId: string) => {
    return axios.post<ResponseObjectUpload>(
      `${BASEURL}/Scan/AttachDocument?EscaneoActividadId=${escaneoActividadId}`,
      data,
      {
        headers: {'Content-Type': 'multipart/form-data'},
      },
    )
  },
  downloadDocument: (escaneoActividadId: string) => {
    return axios.get(`${BASEURL}/Scan/DownloadDocument?EscaneoActividadId=${escaneoActividadId}`)
  },
  getListEscaneoActividadById: (escaneoActividadId: string) => {
    return axios.post<ResponseObject<ScanActivityResponse>>(
      `${BASEURL}/Scan/getListEscaneoActividadById?EscaneoActividadId=${escaneoActividadId}`,
    )
  },
}
